import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";
import { TenantData } from "../interface";

export const createToken = async (tenantName: string, email: string): Promise<any> => {
    const url = `${NGROK}/api/expose/${tenantName}/createToken`;
    const data = await apiClient({
        method: "GET",
        url,
        params: { email: email }
    });

    return data;
};

export const deleteToken = async (tenantName: string, email: string, apiKey: string): Promise<any> => {
    const url = `${NGROK}/api/expose/${tenantName}/deleteToken`;
    const data = await apiClient({
        method: "DELETE",
        url,
        params: { email: email, token: apiKey }
    });

    return data;
};

export const fetchTokens = async (tenantName: string, email: string): Promise<any> => {
    const url = `${NGROK}/api/expose/${tenantName}/getTokens`;
    const data = await apiClient({
        method: "GET",
        url,
        params: { email }
    });

    return data;
};


export const fetchTenants = async (): Promise<TenantData[]> => {
    const url = `${NGROK}/api/get-all-domains`;
    const data = await apiClient<TenantData[]>({
        method: "GET",
        url
    });

    return data;
};


export const generateApiKey = async (tenantName: string): Promise<any> => {
    const url = `${NGROK}/api/${tenantName}/tenant-admin/get-api-key`;
    const data = await apiClient({
        method: "GET",
        url
    });
    return data;
};

export const deleteTenant = async (tenantName: string, apikey: string) => {

    const url = `${NGROK}/api/${tenantName}/tenant-admin/delete-api-key/${apikey}`;
    const data = await apiClient({
        method: "DELETE",
        url
    });

};

